// @ts-nocheck

import palette from '../palette';

export const RegisterModal = {
  backgroundGradient: palette.registermodalbackground,
  RegisterButton: {
    backgroundColor: palette.red200,
    color: palette.white,
  },
  ConnectButton: {
    backgroundColor: palette.bluegrey700,
    color: palette.white,
  },
  BonusText: {
    color: palette.white,
  },
  TaxText: {
    color: palette.yellowwinamax450,
  },
  TermsText: {
    color: palette.neutralgrey350,
  },
};
